import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { handleListResponse, seo } from "utils/utils";
import {
  getVisiterList,
  addAppointment,
  resetAddAppointment,
} from "../../reduxStore/action/appointmentActions";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse, isEmpty } from "../../utils/utils";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  SourcingHead,
} from "../../utils/constants";

const AddAppointment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const params = new URLSearchParams(window.location.search);
  const leadId = params.get("lead_id");
  const propertyId = params.get("property_id");

  useEffect(() => {
    if (leadId) {
      setForm({ ...form, lead_id: leadId, property_id: propertyId });
    }
  }, [leadId, propertyId]);

  const getVisitorListSelector = useSelector(
    (state) => state.appointment?.response?.data
  );

  const propertySelector = useSelector((state) => state.propertyData);

  const addAppointmentSelector = useSelector((state) => state.appointment);

  // const handleInputArea = (e) => {
  //   const nextFormState = {
  //     ...form,
  //     pickup_location: e,
  //     pickup_latitude: "",
  //     pickup_longitude: "",
  //   };
  //   setForm(nextFormState);
  // };
  // const onSelect = (latLng, pickup_location) => {
  //   const nextFormState = {
  //     ...form,
  //     pickup_location: pickup_location,
  //     pickup_latitude: latLng.lat,
  //     pickup_longitude: latLng.lng,
  //   };
  //   setForm(nextFormState);
  // };

   const { response: res } = useSelector((state) => state.login);
  
    const role_id = res?.data?.role_id;
    const Cmteam =
      ClosingTL === role_id ||
      ClosingManager === role_id ||
      closing_head_id === role_id;
  
    const SMteam =
      SourcingTL === role_id ||
      SourcingManager === role_id ||
      sourcing_head_id === role_id;
  
    const mixTeam =
      SCM === role_id ||
      SiteHead === role_id ||
      ClusterHead === role_id ||
      BusinessHead === role_id ||
      admin_id === role_id;

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (appointment_time) => {
    let formErr = { ...formVaild };
    if (appointment_time) {
      const nextFormState = {
        ...form,
        appointment_time: moment("2000-01-01 " + appointment_time).format(
          "hh:mm A"
        ),
      };
      setForm(nextFormState);

      if (!isEmpty(formErr?.appointment_time)) {
        delete formErr.appointment_time;
      }
    } else {
      formErr["appointment_time"] = strings.validTime;
    }
    setFormVaild(formErr);
  };

  useEffect(() => {
    dispatch(getVisiterList({ lead_id: leadId }));
  }, []);

  useEffect(() => {
    if (propertySelector.response) {
      const { response } = propertySelector;
      if (response?.status === 200) {
        setApiResponse(
          handleListResponse(response.data.filter(item => item.status === true))
        );        
      } else {
        setApiResponse([]);
      }
    }
  }, [propertySelector]);

  useEffect(() => {
    dispatch(getAgentProperty({ property_id: propertyId }));
  }, []);

  // JUSTO-88: After successful appointment create – redirect to previous screen and reset state so same details aren't submitted again.
  // Previous logic (commented out – redirect could be lost when create was overwritten by GET_VISITOR_LIST):
  // useEffect(() => {
  //   if (addAppointmentSelector.create === true) {
  //     if (addAppointmentSelector?.addResponse?.status === 200) {
  //       setForm({});
  //       if(SMteam){
  //         navigate("/appointment_site_visit")
  //       }else{
  //         navigatpage("/appointment");
  //       }
  //     }
  //   }
  // }, [addAppointmentSelector]);
  useEffect(() => {
    const status = addAppointmentSelector?.addResponse?.status;
    const isSuccess = status === 200 || status === 201;
    if (!isSuccess) return;

    setForm({});
    if (SMteam) {
      navigate("/appointment_site_visit");
    } else {
      navigate("/appointment");
    }
    dispatch(resetAddAppointment()); // JUSTO-88: Clear add-appointment state so duplicate submit with same data is prevented.
  }, [addAppointmentSelector?.addResponse, dispatch, SMteam, navigate]);

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      form.lead_id && formData.append("lead_id", form.lead_id);
      form.property_id && formData.append("property_id", form.property_id);
      form.appointment_date &&
        formData.append("appointment_date", form.appointment_date);
      form.appointment_time &&
        formData.append("appointment_time", form.appointment_time);

        form.remarks && formData.append("remarks", form.remarks);
        formData.append("visit_status", strings.warm);
        formData.append("type", 1);
      dispatch(addAppointment(formData));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.lead_id) {
      formError = true;
      err["lead_id"] = strings.leadErr;
    }
    if (!form.property_id) {
      formError = true;
      err["property_id"] = strings.propertynameErr;
    }
    if (!form.appointment_date) {
      formError = true;
      err["appointment_date"] = strings.followup_dateErr;
    }
    if (!form.appointment_time) {
      formError = true;
      err["appointment_time"] = strings.followup_timeErr;
    }
    // if (form.pickup === "Yes") {
    //   if (!form.pickup_location) {
    //     formError = true;
    //     err["pickup_location"] = strings.pickupLocationErr;
    //   }
    //   if (!form.pickup_address) {
    //     formError = true;
    //     err["pickup_address"] = strings.addressErr;
    //   }
    //   if (!form.number_of_guest) {
    //     formError = true;
    //     err["number_of_guest"] = strings.numberOfGuest;
    //   } else if (isNaN(form.number_of_guest)) {
    //     formError = true;
    //     err["number_of_guest"] = strings.validNumber;
    //   }
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Add Appointment",
      metaDescription: "Add appointment details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.addAppointment}
        url={"/appointment"}
        parentListing={strings.appointmentList}
        titleactive={strings.addAppointment}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addAppointment}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectLead}
                        <span className="required-field"></span>
                      </label>
                      <select
                        className="form-control"
                        id="exampleFormControlSelect9"
                        name="lead_id"
                        disabled={leadId ? true : false}
                        value={form.lead_id}
                        onChange={(e) => {
                          let property_id = handleDetailResponse(
                            getVisitorListSelector?.filter(
                              (i) => i.lead_id === e.target.value
                            )
                          )?.property_id;
                          const nextFormState = {
                            ...form,
                            lead_id: e.target.value,
                            property_id: property_id ? property_id : "",
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectlead}
                        </option>
                        {getVisitorListSelector?.map((item, index) => (
                          <option key={index} value={item._id}>
                            {`${item.first_name || ""} ${item.last_name || ""}`.trim()}
                          </option>
                        ))}
                      </select>
                      {formVaild?.lead_id && (
                        <span style={{ color: "red" }}>
                          {formVaild?.lead_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectProperty}
                        <span className="required-field"></span>
                      </label>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="property_id"
                        value={form.property_id}
                        disabled={!!leadId}
                        onChange={(e) => {
                          var index = e.nativeEvent.target.selectedIndex;
                          var property_title = e.nativeEvent.target[index].text;
                          const nextFormState = {
                            ...form,
                            property_id: e.target.value,
                            property_title: property_title,
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectProp}
                        </option>
                        {apiResponse &&
                          apiResponse.map((item, index) => (
                            <option key={index} value={item.property_id}>
                              {item.property_title}
                            </option>
                          ))}
                      </select>
                      {formVaild?.property_id && (
                        <span style={{ color: "red" }}>
                          {formVaild?.property_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentDate}
                        <span className="required-field"></span>
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        name="appointment_date"
                        type="Date"
                        value={form?.appointment_date}
                        onChange={handleInputField}
                        min={moment().format("yyyy-MM-DD")}
                        max={moment().add(30, "days").format("yyyy-MM-DD")}
                      />
                      {formVaild?.appointment_date && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_date}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentTime}
                        <i
                          className="fa fa-info-circle pl-1 pr-1"
                          title={strings.AppointmentTimeDetail}
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                        ></i>
                        <span className="required-field"></span>
                      </label>
                      <TimePicker
                        onChange={handleInputTime}
                        value={form?.appointment_time}
                        clockIcon={null}
                        clearIcon={null}
                        disableClock={true}
                        format={"hh:mm a"}
                        className="form-control"
                        name="appointment_time"
                      />
                      {formVaild?.appointment_time && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_time}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
  <div className="col-md-8">
    <div className="form-group">
      <label htmlFor="commentSection">
        {strings.comment} {/* Ensure the proper string for "Comment" */}
      </label>
      <textarea
        className="form-control"
        id="commentSection"
        name="comment"
        rows="4" 
        value={form?.remarks}
        onChange={handleInputField} 
      ></textarea>
      {formVaild?.remarks && (
        <span style={{ color: "red" }}>
          {formVaild?.remarks}
        </span>
      )}
    </div>
  </div>
</div>
                
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddAppointment;
